<template>
  <div :class="$b({ active: showToggle })">
    <button
      :class="$b('button', { checked })"
      @click="handleClick"
    >
      <div :class="$b('button-inner')">
        <VisionIcon
          icon="360"
          size="stretch"
          colour="none"
          :class="$b('360-icon')"
        />
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Product360Toggle',
  props: {
    showToggle: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:activeSlideIndex'],
  data() {
    return {
      checked: false,
    }
  },
  watch: {
    checked() {
      if (this.checked) this.$emit('update:activeSlideIndex', 0)
      else this.$emit('update:activeSlideIndex', 1)
    },
  },
  methods: {
    setState(checked) {
      this.checked = checked
    },
    handleClick(event) {
      this.checked = !this.checked
      this.$nextTick(() => event?.target?.blur())
    },
  },
}
</script>

<style lang="postcss">
.Product360Toggle {
  @apply flex items-center
    opacity-0
    z-20
    pointer-events-none
    transition-opacity;

  &--active {
    @apply opacity-100 pointer-events-auto cursor-pointer;
  }

  .Product360Toggle__360-icon {
    @apply block fill-black;
    width: 18px;

    @screen md {
      width: 30px;
    }
  }
}

.Product360Toggle__button--checked .Product360Toggle__360-icon {
  @apply fill-white;
}

.Product360Toggle__button {
  @apply relative block
    rounded-md
    bg-white;
  transition: background ease-in-out 0.2s;
  -webkit-tap-highlight-color: transparent;

  &--checked {
    @apply text-white;
    background: var(--gradient);
  }

  &::before {
    @apply absolute
      w-full h-full
      top-0 left-0
      rounded-md
      opacity-0 transition-opacity
      mix-blend-darken;

    content: '';
    z-index: 1;
    transition-duration: 300ms;
    background-image: var(--gradient);
  }

  &:hover:not(&--checked)&::before,
  &:focus:not(&--checked)&::before {
    @apply md:opacity-20;
  }
}

.Product360Toggle__button-inner {
  @apply p-xxxs
    flex items-center justify-center;

  height: calc(18px + theme('spacing.xxxs') * 2);

  @screen md {
    height: calc(30px + theme('spacing.xxxs') * 2);
  }
}
</style>
